import CardTemplate from "@appsinti/ui-core/CardTemplate";
import { Row } from "@appsinti/ui-core/styles";
import styled from "styled-components";

export const CustomCardTemplate = styled(CardTemplate)`
   flex: unset;
  .body {
    flex-shrink: 0;
    flex-grow: 0;
  }

  @media screen and (max-height: 710px) {
    .header {
        padding: 2px;
    }
  }
`;

export const CustomRow = styled(Row)`
  text-align: center;
  gap: 2px;
  display: flex;
  margin: 0;
  padding: 0;
  flex-shrink: 0;
  flex-grow: 0;
  align-items: center;
  div {
    display: flex;
    flex: 1;
    display: flex;
    gap: 3px;

    @media screen and (max-height: 750px) {
      gap: 2px;
    }

    &.column {
      flex-direction: column;
    }
    &.row {
      flex-direction: row;
    }

    span {
      flex: 1;
    }
  }
`;
